import { Fragment, type Key, type ReactElement, type ReactNode } from 'react';
import { PopoverPopup, PopoverRoot, PopoverTrigger, usePopoverState } from '@ff-it/ui';
import type { Placement } from '@floating-ui/react';
import { actionDropdownAllowedPlacements } from 'components';
import { wrapper } from './CellPopover/style.css';

export type GridPopover = {
  body: ReactNode;
  closeOnContentClick?: boolean;
  allowedPlacements?: Placement[];
};

const hoverAllowedPlacements: Placement[] = ['bottom-end', 'top-end'];

export function PlanGridHoverPopover({
  children,
  content,
  popoverKey,
}: {
  children: ReactNode;
  content: ReactNode;
  popoverKey: Key;
}): ReactElement {
  return (
    <PopoverTrigger<GridPopover>
      openOnHover="only"
      delay={300}
      payload={{
        body: <Fragment key={popoverKey}>{content}</Fragment>,
        allowedPlacements: hoverAllowedPlacements,
      }}
    >
      <div className={wrapper} tabIndex={-1}>
        {children}
      </div>
    </PopoverTrigger>
  );
}

export function PlanGridPopoverRoot({ children }: { children: ReactNode }): ReactElement {
  return (
    <PopoverRoot<GridPopover>>
      {children}
      <PlanGridPopoverHost />
    </PopoverRoot>
  );
}

function PlanGridPopoverHost(): ReactElement {
  const { payload } = usePopoverState<GridPopover>();

  return (
    <PopoverPopup<GridPopover>
      placement="auto"
      placementOptions={{ allowedPlacements: payload?.allowedPlacements ?? actionDropdownAllowedPlacements }}
      closeOnContentClick={payload?.closeOnContentClick ?? false}
    >
      {payload?.body ?? null}
    </PopoverPopup>
  );
}
